import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

import HowToReg from "@material-ui/icons/HowToReg";
import Memory from "@material-ui/icons/Memory";
import CameraAlt from "@material-ui/icons/CameraAlt";
import Redeem from "@material-ui/icons/Redeem";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import DirectionsRun from "@material-ui/icons/DirectionsRun";
import DirectionsBike from "@material-ui/icons/DirectionsBike";
import Pool from "@material-ui/icons/Pool";

import AppContainer from "../../../AppContainer";
import ParallaxBand from "./ParallaxBand";
import ServiceSection from "./ServiceSection";
import ContactSection from "./ContactSection";
import FullBleedBackground from "./FullBleedBackground";

import logoDashport from "../../../assets/dashport-logos/DASHPORT_03.png";
import fotoPies from "../../../assets/backgroundPhotos/pies_corriendo_con_logo_Dashport.jpg";
import fotoMujer from "../../../assets/backgroundPhotos/mujer_corriendo_Dashport.webp";
import fotoPrincipal from "../../../assets/backgroundPhotos/fotoPrincipal_Dashport_bajaResolucion.webp";
import fotoCorredor from "../../../assets/backgroundPhotos/corredor_con_logo_Dashport.webp";

// Galería - Inscripciones (capturas en vivo del panel admin, evento 572)
import formularioRegistro from "../../../assets/adminScreens/inscripciones/formulario.png";
import inscripcionesDashboard from "../../../assets/adminScreens/inscripciones/dashboard.png";
import listaParticipantes from "../../../assets/adminScreens/inscripciones/lista-participantes.png";
import detalleAtleta from "../../../assets/adminScreens/inscripciones/detalle-atleta.png";

// Galería - Cronometraje (panel admin + app móvil de crono)
import cronometrajeDashboard from "../../../assets/adminScreens/cronometraje/dashboard.png";
import inicioCronometro from "../../../assets/adminScreens/cronometraje/inicio-cronometro.png";
import registroPuntoControl from "../../../assets/adminScreens/cronometraje/registro-punto-control.png";
import resultadosTiempoReal from "../../../assets/adminScreens/cronometraje/resultados-tiempo-real.png";
import announcer from "../../../assets/adminScreens/cronometraje/announcer.png";
import appInicio from "../../../assets/adminScreens/cronometraje/app-inicio.jpeg";
import appCompetidores from "../../../assets/adminScreens/cronometraje/app-competidores.jpeg";

// Galería - Resultados y fotografías
import ganadores from "../../../assets/adminScreens/resultados/ganadores.png";
import detalleResultado from "../../../assets/adminScreens/resultados/detalle-resultado.png";
import certificado from "../../../assets/adminScreens/resultados/certificado.jpg";
import appCapturaFotos from "../../../assets/adminScreens/resultados/app-captura-fotos.jpeg";
import appCamara from "../../../assets/adminScreens/resultados/app-camara.jpeg";

// Galería - Entrega de kits
import moduloKits from "../../../assets/adminScreens/kits/modulo-kits.png";
import detalleEntregaKit from "../../../assets/adminScreens/kits/detalle-entrega.png";

// Logos de eventos reales de 2026 que ya usaron la plataforma
// (obtenidos desde /resultados/ de la propia app, mismos datos que ve cualquier visitante)
const EVENTOS_LOGOS = [
  { nombre: "Marat'hon de Mérida 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FPORTADA%20Dashport_68667.JPG?alt=media&token=29f43c0f-1e44-4217-844f-836db69e9e38" },
  { nombre: "Maratón de la Marina 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FPortada%20para%20Dashport-3_69638.JPG?alt=media&token=c182cd78-3197-40d3-8fd5-126dbd401234" },
  { nombre: "Reto MTB La Rebelión 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2F1000625315_20920.JPG?alt=media&token=768056ba-fd7e-409d-95c0-e612d50644c3" },
  { nombre: "Clásica de las 3 Culturas 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FWhatsApp%20Image%202025-09-12%20at%207.51.23%20AM._72284.JPG?alt=media&token=0a46ad8f-984f-4421-a40a-2479ba9f48f1" },
  { nombre: "Clásica de Verano Yucatán 26", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2F5taCarreraVerano_Fecha_91454.JPG?alt=media&token=26a1e560-03a3-417d-af1e-e0dddc87c6fd" },
  { nombre: "Gran Fondo Yucatán 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FGran%20Fondo%202026%20(1)-04_84683.JPG?alt=media&token=6e010ab9-3fcd-4a8a-885c-7a90595960c8" },
  { nombre: "Carrera La Lupita Mérida 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FWEB%20CARRERA%202026_PORTADA%20MERIDA_62128.JPG?alt=media&token=05bd5b48-d1b1-477b-a963-38d1dacbdf97" },
  { nombre: "Oceanman Cozumel 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FmyOceanman%20Cozumel%20M%C3%A9xico_page-0001_94931.JPG?alt=media&token=7f420d7b-08d8-4f33-b61b-4205c2e645ad" },
  { nombre: "21K Chetumal 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FIDENTIDAD%20GR%C3%81FICA-08_42557.JPG?alt=media&token=d0f49996-6162-420f-a103-91b0d76a26e1" },
  { nombre: "Duatlón Mérida 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FDise%C3%B1os%20Duatl%C3%B3n-05_13592.JPG?alt=media&token=dbc4cc19-5c58-4e82-8995-4e7959cc103f" },
  { nombre: "Coahuila 1000 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2Fcoahuila%201000._45737.JPG?alt=media&token=7e62e65d-9948-48c8-ba1c-13ef907d8f9c" },
  { nombre: "Cholula Trail 4ta edición", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FCUADRO%20BANNER%20%20(9)_2473.JPG?alt=media&token=568af5d5-97a5-4ff0-af83-3e6428f8ae9e" },
  { nombre: "Somos Runners Ciudad del Carmen 2026", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FSOMOS%20RUNNERS%20Ciudad%20dek%20Carmen-01_92124.JPG?alt=media&token=64b39f34-3939-4a82-b7eb-6f8127e14394" },
  { nombre: "Reto de los Cerros 26", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FRETO%20DE%20LOS%20CERROS%2026%20logo%201._81634.JPG?alt=media&token=bb5c8420-e84f-4dfd-9d3d-cef3e79f6cb6" },
  { nombre: "NOS - Non Stop Campeche", logo: "https://firebasestorage.googleapis.com/v0/b/kmetasfirebase.appspot.com/o/fotosEventos%2FlogoEvento%2FLogo._81934.JPG?alt=media&token=b2efa75f-7775-4990-81de-d547d135badd" },
];

const GALERIA_INSCRIPCIONES = [
  { imagen: formularioRegistro, titulo: "Formulario de registro", detalle: "Formulario en vivo para completar los datos del atleta al inscribirse." },
  { imagen: inscripcionesDashboard, titulo: "Dashboard de inscripciones", detalle: "Total cobrado, desglose por forma de pago (efectivo, OXXO, tarjeta) e inscritos por modalidad y rama en tiempo real." },
  { imagen: listaParticipantes, titulo: "Reporte de inscritos", detalle: "Lista de participantes por modalidad, rama y categoría, con descarga en CSV." },
  { imagen: detalleAtleta, titulo: "Detalle del atleta inscrito", detalle: "Vista para editar y revisar la información de cada atleta (datos de contacto ocultos en esta muestra)." },
];

const GALERIA_CRONOMETRAJE = [
  { imagen: cronometrajeDashboard, titulo: "Dashboard de avance del evento", detalle: "Seguimiento en tiempo real: participantes, finishers y avance por cada punto de control." },
  { imagen: inicioCronometro, titulo: "Control de salida", detalle: "Inicio del cronómetro de cada serie de salida desde la aplicación." },
  { imagen: registroPuntoControl, titulo: "Registro en punto de control", detalle: "Captura manual del número de competidor al cruzar un punto de control." },
  { imagen: resultadosTiempoReal, titulo: "Resultados en tiempo real", detalle: "Tiempo oficial en meta por atleta conforme van llegando." },
  { imagen: announcer, titulo: "Vista del animador (announcer)", detalle: "Pantalla usada para anunciar en vivo a los atletas que cruzan la meta." },
  { imagen: appInicio, titulo: "App de cronometraje: inicio", detalle: "Selección de puntos de control del evento desde la app móvil." },
  { imagen: appCompetidores, titulo: "App de cronometraje: competidores", detalle: "Búsqueda y lista de competidores por modalidad desde la app móvil." },
];

const GALERIA_RESULTADOS = [
  { imagen: ganadores, titulo: "Lista de ganadores", detalle: "Ganadores por rama y categoría con tiempo oficial, generados automáticamente." },
  { imagen: detalleResultado, titulo: "Detalle de resultado de un atleta", detalle: "Tiempo oficial, tiempo chip, paso por kilómetro y posiciones, con descarga en JPG o PDF." },
  { imagen: certificado, titulo: "Certificado de participación", detalle: "Certificado personalizado con el diseño del evento, tiempo oficial y posiciones del atleta." },
  { imagen: appCapturaFotos, titulo: "App de fotografía: captura", detalle: "Configuración de punto fotográfico y captura continua durante el evento." },
  { imagen: appCamara, titulo: "App de fotografía: cámara", detalle: "Cámara con geolocalización para asociar las fotos al punto del recorrido." },
];

const GALERIA_KITS = [
  { imagen: moduloKits, titulo: "Módulo de entrega de kits", detalle: "Búsqueda por QR, nombre o número, con avance de kits entregados y por entregar en tiempo real." },
  { imagen: detalleEntregaKit, titulo: "Detalle de entrega por atleta", detalle: "Datos de inscripción, artículos del kit y confirmación de entrega al atleta o a un tercero." },
];

const useStyles = makeStyles((theme) => ({
  intro: {
    textAlign: "center",
    padding: theme.spacing(6, 2),
  },
  introLogo: {
    width: 320,
    maxWidth: "80%",
    marginBottom: theme.spacing(2),
  },
  eventosLogos: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: theme.spacing(2),
  },
  eventoLogo: {
    height: 180,
    width: 180,
    objectFit: "contain",
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    padding: theme.spacing(1),
    backgroundColor: "#fff",
  },
  eventosHeading: {
    textAlign: "center",
    marginTop: theme.spacing(6),
  },
  eventosSection: {
    paddingBottom: theme.spacing(4),
  },
}));

const MODALIDADES = [
  { icon: DirectionsRun, label: "Pedestres" },
  { icon: DirectionsBike, label: "Ciclismo" },
  { icon: Pool, label: "Aguas abiertas" },
];

const DashportServicesList = () => {
  const classes = useStyles();

  const irAInscripciones = () => {
    const el = document.getElementById("inscripciones");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <AppContainer>
      <ParallaxBand imageSrc={fotoPies} />

      <FullBleedBackground id="inicio">
        <div className={classes.intro}>
          <img src={logoDashport} alt="Dashport" className={classes.introLogo} />
          <Typography variant="h5" component="h1" gutterBottom>
            Servicios tecnológicos para eventos deportivos de resistencia.
          </Typography>
          <Typography variant="body1" color="textSecondary" paragraph>
            Nuestros servicios tecnológicos ayudan a mejorar la experiencia del
            participante en los eventos deportivos y simplifican el trabajo de
            los organizadores y cronometradores.
          </Typography>
          <Typography variant="subtitle1" gutterBottom>
            Conoce nuestras herramientas
          </Typography>
          <Button color="primary" onClick={irAInscripciones}>
            <KeyboardArrowDown fontSize="large" />
          </Button>
        </div>
      </FullBleedBackground>

      <ParallaxBand imageSrc={fotoMujer} />

      <ServiceSection
        id="inscripciones"
        icon={HowToReg}
        titulo="Inscripciones"
        parrafos={[
          "Gestiona con total tranquilidad y de forma simple el registro de todos los participantes al evento, el pago, la asignación de números de competencia, categorías y distancias. Cuenta con opciones de pago en efectivo a través de puntos de venta y opciones en línea con pago en OXXO, tarjetas de débito y crédito.",
          "La mejor plataforma para vender inscripciones (como una boletera tradicional) con los requerimientos que demandan los eventos de resistencia.",
          "Contáctanos por más información.",
        ]}
        ventajas={[
          "Configurar cualquier tipo de evento deportivo.",
          <>Podrás requerir a los participantes toda la información necesaria para el evento usando <b>campos personalizados</b> (ej. talla, equipo de corredores y cualquier otro).</>,
          <><b>Vende productos adicionales</b> a la inscripción por sí misma; estos productos pueden segmentarse por la modalidad o sub evento en el que el atleta desea participar.</>,
          <>Habilita <b>múltiples puntos de venta</b> para pago en efectivo sin costo adicional (tiendas deportivas locales, de patrocinadores, clubes de corredores entre otros).</>,
          <>Disponibilidad las 24 horas de forma online para inscripciones y consulta de estadísticas del evento en <b>tiempo real</b>.</>,
        ]}
        galeria={GALERIA_INSCRIPCIONES}
      />

      <FullBleedBackground className={classes.eventosSection}>
        <Typography variant="h5" component="h3" className={classes.eventosHeading}>
          Eventos que ya usaron nuestra plataforma de inscripciones
        </Typography>
        <div className={classes.eventosLogos}>
          {EVENTOS_LOGOS.map(({ nombre, logo }) => (
            <img key={nombre} src={logo} alt={nombre} title={nombre} className={classes.eventoLogo} />
          ))}
        </div>
      </FullBleedBackground>

      <ParallaxBand imageSrc={fotoPrincipal} />

      <ServiceSection
        id="kits"
        icon={Redeem}
        titulo="Entrega de kits"
        parrafos={[
          "Simplifica y controla la entrega de kits el día del evento: busca al atleta por QR, nombre o número, confirma los artículos que le corresponden y registra la entrega sin usar papel.",
          "Consulta en cualquier momento el avance de kits entregados y por entregar, con reportes descargables por punto de entrega.",
          "Contáctanos por más información.",
        ]}
        ventajas={[
          "Búsqueda instantánea por código QR, nombre o número de atleta.",
          <><b>Múltiples módulos de entrega</b>: configura uno por cada punto de contacto con el atleta.</>,
          "Entrega al atleta o a un tercero, quedando registrada en cada caso.",
          "Reportes de kits entregados y por entregar en tiempo real.",
        ]}
        galeria={GALERIA_KITS}
      />

      <ParallaxBand imageSrc={fotoCorredor} />

      <ServiceSection
        id="cronometraje"
        icon={Memory}
        titulo="Cronometraje"
        parrafos={[
          "Cronometraje de eventos de resistencia eficiente, fácil de utilizar y accesible para que ningún evento se realice sin este servicio. Todos los atletas tendrán sus tiempos generales, por rama y categoría, así como la capacidad de comparar su desempeño con los demás competidores.",
          "Contamos con dos formas de cronometrar tu evento: aplicación móvil (registro manual por punto de control) o chip RFID, ya disponible para carreras pedestres, ciclismo y aguas abiertas.",
          "Contáctanos por más información.",
        ]}
        ventajas={[
          <><b>Bajo costo</b> para el organizador: la opción de aplicación móvil no requiere que los atletas usen chip ni equipos costosos.</>,
          "Alcance similar al de los chips en eventos de mediana o baja participación con la opción de aplicación móvil.",
          <><b>Múltiples puntos de control</b> sin costo adicional más allá del costo del operador.</>,
          "Chip RFID disponible para carreras pedestres, ciclismo y aguas abiertas, con lectura automática en cada punto de control.",
          <>Seguimiento en <b>tiempo real</b> de los atletas que cruzan los puntos de control y la meta.</>,
        ]}
        galeria={GALERIA_CRONOMETRAJE}
      >
        <Grid container spacing={2} justifyContent="center">
          {MODALIDADES.map(({ icon: Icon, label }) => (
            <Grid item key={label} style={{ textAlign: "center" }}>
              <Icon color="primary" />
              <Typography variant="caption" display="block">
                {label}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </ServiceSection>

      <ParallaxBand imageSrc={fotoPrincipal} />

      <ServiceSection
        id="resultados"
        icon={CameraAlt}
        titulo="Resultados y Fotografías"
        parrafos={[
          "Plataforma web usada para que los atletas puedan consultar los resultados de cada evento en el que participan y descargar las fotografías en los eventos que contraten este servicio.",
          "Contáctanos por más información.",
        ]}
        ventajas={[
          "Cada atleta tendrá información de su tiempo oficial del evento, la posición que ocupó respecto a los atletas de su misma categoría, rama y la posición general del evento.",
          "Los resultados son los generados por nuestra plataforma de cronometraje u otra que el cliente desee utilizar.",
          "Los atletas podrán descargar su certificado oficial de participación del evento en formato JPG y PDF con su tiempo oficial y posiciones ocupadas.",
          "La plataforma de fotografías permite a todos los atletas editar (cortar, agregar marcos) y descargar muy fácilmente y de forma gratuita todas sus fotos.",
          "Las fotografías pueden incluir el logo del evento y/o de patrocinadores, aumentando la exposición de marcas y del evento en las redes sociales de los atletas.",
        ]}
        galeria={GALERIA_RESULTADOS}
      />

      <ParallaxBand imageSrc={fotoMujer} />

      <ContactSection />
    </AppContainer>
  );
};

export default DashportServicesList;
